import * as navigation from './store'

export function navegacaoV2Module({ store }) {
  // Evita re-registro (warning do Vuex) em hot-reload / testes que importam o
  // módulo mais de uma vez.
  if (typeof store.hasModule === 'function' && store.hasModule('navigation')) {
    return
  }
  store.registerModule('navigation', { ...navigation, namespaced: true })
}
